import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./Reveal";
import { Diya, Rangoli, Rakhi, Potli, Hanging } from "./motifs";
import { wa } from "@/lib/site";

const OCCASIONS = [
    { name: "Diwali", items: "Rangoli mats · Diya holders", Motif: Diya, accent: "#EA580C" },
    { name: "Ganesh Chaturthi", items: "Rangoli mats · Bajot / Chowki", Motif: Rangoli, accent: "#BE123C" },
    { name: "Raksha Bandhan", items: "Premium rakhi merchandise", Motif: Rakhi, accent: "#E2BA03" },
    { name: "Pooja & Home Mandir", items: "Aasan mats · Bajot / Chowki", Motif: Hanging, accent: "#047857" },
    { name: "Weddings & Return Gifts", items: "Potli bags · Chowki", Motif: Potli, accent: "#BE123C" },
];

const Occasions = () => (
    <section id="occasions" data-testid="occasions-section" className="relative py-28 sm:py-40">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                eyebrow="Shop by Occasion"
                title={<>Every Celebration, <em className="italic text-[#E2BA03] [text-shadow:0_1px_0_#472500]">Styled Just Right</em></>}
                testId="occasions-heading"
                className="mb-16 sm:mb-20 max-w-4xl"
            />
            <div className="flex flex-wrap gap-4 sm:gap-5">
                {OCCASIONS.map((o, i) => (
                    <motion.a
                        key={o.name}
                        href={wa(`Hi Festive Theory! I'm shopping for ${o.name} — could you share what's available?`)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`occasion-card-${o.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        initial={{ y: 36, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.75, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                        viewport={{ once: true, margin: "-60px" }}
                        className="group relative flex items-center gap-5 rounded-full border border-[#472500]/20 bg-[#F7F4EC] pl-4 pr-7 py-4 transition-all duration-400 hover:-translate-y-1.5 hover:border-[#472500]/45 hover:shadow-[0_20px_40px_-20px_rgba(71,37,0,0.35)]"
                    >
                        <span
                            className="grid place-items-center w-14 h-14 rounded-full border transition-transform duration-500 group-hover:rotate-12"
                            style={{ borderColor: `${o.accent}55`, color: o.accent, backgroundColor: `${o.accent}0d` }}
                        >
                            <o.Motif className="w-8 h-8" />
                        </span>
                        <span>
                            <span className="block font-display text-lg sm:text-xl text-[#472500]">{o.name}</span>
                            <span className="block text-xs sm:text-sm text-[#472500]/60 mt-0.5">{o.items}</span>
                        </span>
                        <ArrowUpRight
                            size={17}
                            className="text-[#472500]/40 transition-all duration-300 group-hover:text-[#472500] group-hover:rotate-45"
                        />
                    </motion.a>
                ))}
            </div>
            <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.3 }}
                viewport={{ once: true }}
                className="mt-10 text-sm text-[#472500]/55 max-w-xl"
            >
                Tap an occasion to start a WhatsApp chat — we'll help you pick the perfect pieces for it.
            </motion.p>
        </div>
    </section>
);

export default Occasions;
